import React from 'react';

const Play = ({ className = '', title = '' }) => {
  return (
    <svg className={className} width="22" height="34" viewBox="0 0 22 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title lang="en">{title}</title>
      <path d="M20.6145 14.7963C21.9003 15.9841 21.9003 18.0159 20.6145 19.2037L5.53565 33.1329C3.61421 34.9078 0.5 33.545 0.5 30.9292L0.500001 3.07079C0.500002 0.454991 3.61421 -0.907823 5.53566 0.867128L20.6145 14.7963Z" fill="#FCEE21"/>
    </svg>
  )
};

export default Play;
